<div class="screen">
  <div class="screen-inner">
    <app-shell nav="close" action="none" title="New event" [backTo]="backTo"></app-shell>

    <form class="form" (ngSubmit)="save()">
      <label class="field">
        <span class="field-label">Event name</span>
        <input name="name" [(ngModel)]="name" placeholder="Week 4" />
        @if (fieldErrors['name']) { <span class="field-error">{{ fieldErrors['name'] }}</span> }
      </label>

      <label class="field">
        <span class="field-label">Format</span>
        <select name="format" [(ngModel)]="format">
          @for (option of formats; track option.id) {
            <option [ngValue]="option.id">{{ option.label }}</option>
          }
        </select>
      </label>

      <label class="field">
        <span class="field-label">Date</span>
        <input name="startDate" type="date" [(ngModel)]="startDate" />
        @if (fieldErrors['startDate']) { <span class="field-error">{{ fieldErrors['startDate'] }}</span> }
      </label>

      <label class="field">
        <span class="field-label">Last day</span>
        <input name="endDate" type="date" [(ngModel)]="endDate" />
        <span class="field-hint">Leave blank for a single day event.</span>
      </label>

      <label class="field">
        <span class="field-label">Entry fee</span>
        <input name="entryFee" type="number" inputmode="decimal" step="0.01" [(ngModel)]="entryFee" />
      </label>

      @if (selectedFormat.team) {
        @if (selectedFormat.teamSize === null) {
          <label class="field">
            <span class="field-label">Players per team</span>
            <input name="teamSize" type="number" inputmode="numeric" min="2" max="4" [(ngModel)]="teamSize" />
          </label>
        } @else {
          <p class="page-note">{{ selectedFormat.label }} always plays {{ selectedFormat.teamSize }} per team.</p>
        }

        <label class="field-check">
          <input name="playersPickTeams" type="checkbox" [(ngModel)]="playersPickTeams" />
          <span>Players pick their own teams</span>
        </label>
      }

      <p class="section-label">Side games</p>

      <label class="field-check">
        <input name="ctpEnabled" type="checkbox" [(ngModel)]="ctpEnabled" />
        <span>Closest to the pin</span>
      </label>
      @if (ctpEnabled) {
        <label class="field">
          <span class="field-label">Closest to pin fee</span>
          <input name="ctpEntryFee" type="number" inputmode="decimal" step="0.01" [(ngModel)]="ctpEntryFee" />
        </label>
      }

      <label class="field-check">
        <input name="longDriveEnabled" type="checkbox" [(ngModel)]="longDriveEnabled" />
        <span>Long drive</span>
      </label>
      @if (longDriveEnabled) {
        <label class="field">
          <span class="field-label">Long drive fee</span>
          <input name="longDriveEntryFee" type="number" inputmode="decimal" step="0.01" [(ngModel)]="longDriveEntryFee" />
        </label>
      }

      @if (error) { <p class="error">{{ error }}</p> }

      <button class="btn-primary" type="submit" [disabled]="saving">Create event</button>
    </form>
  </div>
</div>
